import { render, staticRenderFns } from "./versionList.vue?vue&type=template&id=b92825ce&scoped=true"
import script from "./versionList.vue?vue&type=script&lang=js"
export * from "./versionList.vue?vue&type=script&lang=js"
import style0 from "./versionList.vue?vue&type=style&index=0&id=b92825ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92825ce",
  null
  
)

export default component.exports